<div class="item">
    <span class="item__title">
        {{ eventData.ED.Dc }}
    </span>

    <span class="item__desc">
        <tk-event-list-alarm-item-info [event]="eventData"></tk-event-list-alarm-item-info>
    </span>

    <span class="item__time">
        {{ eventData.TS | date : 'HH:mm' }}
    </span>

    <!-- <div *ngIf="eventData.ES === EVENT_STATUS.Unread" class="item__read-status"></div> -->
</div>
